import clsx from "clsx";

export const WrapperChatSender = ({ children, classNames }) => {
    return <div className={clsx(
        "w-fit p-3 rounded-xl rounded-tl-none bg-chat-sender",
        classNames
    )}>{children}</div>;
};

export const TextChatSender = ({ children, classNames }) => {
    return <p className={clsx(
        "text-xs font-normal text-[#4D586C] leading-[20.4px] tracking-text",
        classNames
    )}>{children}</p>;
};